import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector) // Detect language from browser or localStorage
  .use(initReactI18next)
  .init({    
    lng: (localStorage.getItem('i18nextLng') || navigator.language || 'EN').toUpperCase(),
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
    },
    ns: [
      'translation', 'alerts', 'charts', 'commands', 'dataRegisters',
      'parameters', 'parametersPage', 'parametersLabels',
      'dataRegistersLabels', 'gateways'
    ],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
  });

// Preload languages in memory to avoid unnecessary external calls
i18n.loadLanguages(["EN", "ES", "FR", "DE", "IT"]);

export default i18n;
